import i18next from 'i18next'

export function validateFileType(file: File, acceptedTypes: readonly string[]): boolean {
  return acceptedTypes.includes(file.type)
}

export function validateFileSize(file: File, maxSizeMB: number): boolean {
  return file.size <= maxSizeMB * 1024 * 1024
}

/**
 * Rút gọn MIME (vd. "image/png") thành tên hiển thị thân thiện (PNG/JPEG/WEBP/MP3...).
 */
function toFriendlyTypeLabel(mime: string): string {
  const subtype = mime.split('/')[1] ?? mime
  return subtype.toUpperCase()
}

export function getFileValidationError(
  file: File,
  config: { acceptedTypes: readonly string[]; maxSizeMB: number; kind: 'image' | 'audio' },
): string | null {
  if (file.size <= 0) {
    return i18next.t('common.upload.fileEmpty')
  }
  if (!validateFileType(file, config.acceptedTypes)) {
    const types = config.acceptedTypes.map(toFriendlyTypeLabel).join(', ')
    return i18next.t(
      config.kind === 'image' ? 'common.upload.invalidImageType' : 'common.upload.invalidAudioType',
      { types },
    )
  }
  if (!validateFileSize(file, config.maxSizeMB)) {
    const fileSize = (file.size / (1024 * 1024)).toFixed(2)
    return i18next.t(
      config.kind === 'image' ? 'common.upload.imageTooLarge' : 'common.upload.audioTooLarge',
      { maxSize: config.maxSizeMB, fileSize },
    )
  }
  return null
}
